import API from '../utils/api';

export const getBanners = async (queryParams = { limit: 10, skip: 0 }) => {
   let query = `limit=${queryParams.limit}&skip=${queryParams.skip}`

   if (queryParams.banner_name) {
      query += `&banner_name=${queryParams.banner_name}`
   }

   return API.get(`/common/banner/list?${query}`);
}

export const addUpdateBanner = async (bannerData) => {
   return API.post(`/common/banner/add`, bannerData);
}

export const deleteBanner = async (bannerId = "") => {
   return API.delete(`/common/banner/delete/${bannerId}`);
}

export const getFoodCategory = async (queryParams = {}) => {
   let query = ""

   if (queryParams.status) {
      query += `&status=${queryParams.status}`
   }

   return API.get(`/admin/category/get?${query}`);
}
